module.exports = __webpack_public_path__ + "static/addAccountBanner-aa59491e6be683448ab00f4f91e16980.png";